import { graphql } from 'gql.tada';
import { useQuery } from '@apollo/client';

const MyFamilyBillingQuery = graphql.persisted(
  "MyFamilyBilling",
  graphql(`
    query MyFamilyBilling($schoolId: ID!, $schoolYearId: ID!, $familyId: ID) {
      myFamilyBilling(schoolId: $schoolId, schoolYearId: $schoolYearId, familyId: $familyId) {
        familyEnrollmentId
        enrollmentState
        paymentMethod {
          summary
          methodType
          last4
          autopayEnabled
        }
        invoices {
          invoiceId
          key
          displayStatus
          amountCents
          dueDate
          postedAt
          memo
          autopayStatus
          autopayFailureReason
          automaticPaymentAuthorized
          automaticPaymentAuthorizationSource
          stripeCollectionMethod
          stripeHostedInvoiceUrl
          payableWithSavedMethod
          lineItems {
            lineItemId
            description
            amountCents
            lineType
            person { firstName }
          }
        }
      }
    }
  `)
);

export { MyFamilyBillingQuery };

export function useMyFamilyBillingQuery(schoolId: string | undefined, schoolYearId: string | undefined, familyId?: string) {
  return useQuery(MyFamilyBillingQuery, {
    variables: { schoolId: schoolId!, schoolYearId: schoolYearId!, familyId: familyId ?? null },
    skip: !schoolId || !schoolYearId,
  });
}
